export default {
	methods: {
		_removeIntersectionObserver() {
			this.$data._intersectionObserver?.disconnect();
			this.$data._intersectionObserver = null;
		},
		_createIntersectionObserver(callback) {
			this._removeIntersectionObserver(); // first we remove the old intersection observer
			this.$data._intersectionObserver = new IntersectionObserver((...args) => callback(...args));
		},
	},
	data() {
		return { _intersectionObserver: null };
	},
};
